import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "user-management" };
const _hoisted_2 = { class: "d-flex align-center" };
const _hoisted_3 = {
    key: 0,
    class: "d-flex justify-center align-center pa-8"
};
const _hoisted_4 = {
    key: 2,
    class: "pa-4"
};
const _hoisted_5 = { class: "d-flex align-center" };
const _hoisted_6 = { class: "text-body-2 text-white" };
const _hoisted_7 = { class: "font-weight-medium" };
const _hoisted_8 = {
    key: 0,
    class: "text-body-2"
};
const _hoisted_9 = {
    key: 1,
    class: "text-caption text-medium-emphasis"
};
const _hoisted_10 = { class: "d-flex flex-wrap gap-1" };
const _hoisted_11 = {
    key: 1,
    class: "text-medium-emphasis text-caption"
};
const _hoisted_12 = { class: "d-flex flex-wrap gap-1" };
const _hoisted_13 = {
    key: 1,
    class: "text-medium-emphasis text-caption"
};
const _hoisted_14 = { class: "d-flex gap-1" };
const _hoisted_15 = ["colspan"];
const _hoisted_16 = { class: "permission-editor" };
const _hoisted_17 = { class: "text-subtitle-2 mb-3 d-flex align-center" };
const _hoisted_18 = { class: "d-flex align-center mb-2" };
const _hoisted_19 = { class: "d-flex align-center gap-2" };
const _hoisted_20 = { class: "d-flex align-center justify-space-between" };
const _hoisted_21 = { class: "d-flex align-center" };
const _hoisted_22 = {
    key: 0,
    class: "text-caption text-medium-emphasis mt-1"
};
const _hoisted_23 = { class: "text-caption text-medium-emphasis mb-2" };
const _hoisted_24 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_25 = { class: "d-flex flex-wrap gap-1" };
const _hoisted_26 = {
    key: 1,
    class: "text-caption text-medium-emphasis mb-3"
};
const _hoisted_27 = { key: 2 };
const _hoisted_28 = { class: "d-flex align-center gap-2" };
const _hoisted_29 = {
    key: 3,
    class: "text-caption text-medium-emphasis"
};
const _hoisted_30 = { class: "text-caption text-medium-emphasis mb-2" };
const _hoisted_31 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_32 = { class: "d-flex flex-wrap gap-1" };
const _hoisted_33 = {
    key: 1,
    class: "text-caption text-medium-emphasis mb-3"
};
const _hoisted_34 = { key: 2 };
const _hoisted_35 = { class: "d-flex align-center gap-2" };
const _hoisted_36 = {
    key: 3,
    class: "text-caption text-medium-emphasis"
};
import { ref, computed, onMounted, reactive } from "vue";
import { dserverApi } from "@/services/dserverApi";
import { useAuthStore } from "@/stores/auth";
import { useNotificationStore } from "@/stores/notifications";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserManagement',
    setup(__props) {
        const auth = useAuthStore();
        const notifications = useNotificationStore();
        // State
        const users = ref([]);
        const baseUris = ref([]);
        const loading = ref(true);
        const initialLoading = ref(true);
        const saving = ref(false);
        const deleting = ref(false);
        const error = ref(null);
        const searchQuery = ref("");
        // Expanded rows for inline permission editing
        const expandedRows = ref([]);
        // Inline permission management state
        const savingPermission = ref(null);
        const savingAdmin = ref(null);
        const savingDisplayName = ref(null);
        const pendingSearchPermission = reactive({});
        const pendingRegisterPermission = reactive({});
        const pendingDisplayName = reactive({});
        // Dialogs
        const showAddUserDialog = ref(false);
        const showDeleteDialog = ref(false);
        // Form data
        const newUser = reactive({
            username: "",
            is_admin: false,
        });
        const newUserErrors = reactive({
            username: "",
        });
        const userToDelete = ref(null);
        // Table headers
        const headers = [
            { title: "Username", key: "username", sortable: true },
            { title: "Display Name", key: "display_name", sortable: true },
            { title: "Role", key: "is_admin", sortable: true, width: "100" },
            {
                title: "Search Permissions",
                key: "search_permissions_on_base_uris",
                sortable: false,
            },
            {
                title: "Register Permissions",
                key: "register_permissions_on_base_uris",
                sortable: false,
            },
            { title: "Actions", key: "actions", sortable: false, width: "100" },
        ];
        // Computed
        const currentUsername = computed(() => auth.username);
        const filteredUsers = computed(() => {
            if (!searchQuery.value)
                return users.value;
            const query = searchQuery.value.toLowerCase();
            return users.value.filter((user) => user.username.toLowerCase().includes(query));
        });
        // Methods
        function formatUri(uri) {
            // Extract just the bucket/path part for display
            return uri.replace(/^s3:\/\//, "").split("/")[0] || uri;
        }
        // Get base URIs not yet assigned for search permission
        function getAvailableSearchUris(user) {
            const currentPerms = user.search_permissions_on_base_uris || [];
            return baseUris.value.filter((uri) => !currentPerms.includes(uri));
        }
        // Get base URIs not yet assigned for register permission
        function getAvailableRegisterUris(user) {
            const currentPerms = user.register_permissions_on_base_uris || [];
            return baseUris.value.filter((uri) => !currentPerms.includes(uri));
        }
        // Inline permission management functions
        async function saveDisplayName(username) {
            const newDisplayName = pendingDisplayName[username];
            if (newDisplayName === undefined)
                return;
            savingDisplayName.value = username;
            try {
                // Use null to clear the display name, or the new value
                const displayNameValue = newDisplayName === "" ? null : newDisplayName;
                await dserverApi.updateUser(username, { display_name: displayNameValue });
                notifications.success(`Display name updated for "${username}"`);
                delete pendingDisplayName[username];
                await loadData();
            }
            catch (e) {
                console.error("Failed to update display name:", e);
                notifications.error("Failed to update display name");
            }
            finally {
                savingDisplayName.value = null;
            }
        }
        async function toggleAdminStatus(username, isAdmin) {
            savingAdmin.value = username;
            try {
                await dserverApi.updateUserAdmin(username, isAdmin);
                notifications.success(`User "${username}" ${isAdmin ? "promoted to admin" : "demoted from admin"}`);
                await loadData();
            }
            catch (e) {
                console.error("Failed to update admin status:", e);
                notifications.error("Failed to update admin status");
            }
            finally {
                savingAdmin.value = null;
            }
        }
        async function grantSearchPermission(username) {
            const uri = pendingSearchPermission[username];
            if (!uri)
                return;
            savingPermission.value = `search-grant-${username}`;
            try {
                await dserverApi.grantSearchPermission(username, uri);
                notifications.success(`Search permission granted on ${formatUri(uri)}`);
                delete pendingSearchPermission[username];
                await loadData();
            }
            catch (e) {
                console.error("Failed to grant search permission:", e);
                notifications.error("Failed to grant search permission");
            }
            finally {
                savingPermission.value = null;
            }
        }
        async function revokeSearchPermission(username, uri) {
            savingPermission.value = `search-revoke-${username}-${uri}`;
            try {
                await dserverApi.revokeSearchPermission(username, uri);
                notifications.success(`Search permission revoked from ${formatUri(uri)}`);
                await loadData();
            }
            catch (e) {
                console.error("Failed to revoke search permission:", e);
                notifications.error("Failed to revoke search permission");
            }
            finally {
                savingPermission.value = null;
            }
        }
        async function grantRegisterPermissionInline(username) {
            const uri = pendingRegisterPermission[username];
            if (!uri)
                return;
            savingPermission.value = `register-grant-${username}`;
            try {
                await dserverApi.grantRegisterPermission(username, uri);
                notifications.success(`Register permission granted on ${formatUri(uri)}`);
                delete pendingRegisterPermission[username];
                await loadData();
            }
            catch (e) {
                console.error("Failed to grant register permission:", e);
                notifications.error("Failed to grant register permission");
            }
            finally {
                savingPermission.value = null;
            }
        }
        async function revokeRegisterPermission(username, uri) {
            savingPermission.value = `register-revoke-${username}-${uri}`;
            try {
                await dserverApi.revokeRegisterPermission(username, uri);
                notifications.success(`Register permission revoked from ${formatUri(uri)}`);
                await loadData();
            }
            catch (e) {
                console.error("Failed to revoke register permission:", e);
                notifications.error("Failed to revoke register permission");
            }
            finally {
                savingPermission.value = null;
            }
        }
        async function loadData() {
            loading.value = true;
            error.value = null;
            try {
                const [userList, baseUriList] = await Promise.all([
                    dserverApi.listUsers(),
                    dserverApi.listBaseURIs(),
                ]);
                users.value = userList;
                baseUris.value = baseUriList.map((b) => b.base_uri);
            }
            catch (e) {
                console.error("Failed to load user data:", e);
                error.value = "Failed to load user data. Please try again.";
            }
            finally {
                loading.value = false;
                initialLoading.value = false;
            }
        }
        function closeAddUserDialog() {
            showAddUserDialog.value = false;
            newUser.username = "";
            newUser.is_admin = false;
            newUserErrors.username = "";
        }
        async function createUser() {
            // Validate
            if (!newUser.username.trim()) {
                newUserErrors.username = "Username is required";
                return;
            }
            if (users.value.some((u) => u.username === newUser.username)) {
                newUserErrors.username = "Username already exists";
                return;
            }
            newUserErrors.username = "";
            saving.value = true;
            try {
                await dserverApi.createUser(newUser.username, {
                    is_admin: newUser.is_admin,
                });
                notifications.success(`User "${newUser.username}" created successfully`);
                closeAddUserDialog();
                await loadData();
            }
            catch (e) {
                console.error("Failed to create user:", e);
                notifications.error("Failed to create user. Please try again.");
            }
            finally {
                saving.value = false;
            }
        }
        function openDeleteDialog(user) {
            userToDelete.value = user;
            showDeleteDialog.value = true;
        }
        async function confirmDeleteUser() {
            if (!userToDelete.value)
                return;
            deleting.value = true;
            try {
                await dserverApi.deleteUser(userToDelete.value.username);
                notifications.success(`User "${userToDelete.value.username}" deleted successfully`);
                showDeleteDialog.value = false;
                userToDelete.value = null;
                await loadData();
            }
            catch (e) {
                console.error("Failed to delete user:", e);
                notifications.error("Failed to delete user. Please try again.");
            }
            finally {
                deleting.value = false;
            }
        }
        onMounted(() => {
            loadData();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_avatar = _resolveComponent("v-avatar");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_switch = _resolveComponent("v-switch");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_data_table = _resolveComponent("v-data-table");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_card, {
                    variant: "elevated",
                    rounded: "lg",
                    class: "fill-height"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "d-flex align-center justify-space-between pa-4 border-b" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_v_icon, {
                                        size: "24",
                                        color: "primary",
                                        class: "mr-2"
                                    }, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                _createTextVNode("mdi-account-group", -1)
                                            ]))]),
                                        _: 1
                                    }),
                                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-h6" }, "User Management", -1))
                                ]),
                                _createVNode(_component_v_btn, {
                                    color: "primary",
                                    variant: "tonal",
                                    "prepend-icon": "mdi-account-plus",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (showAddUserDialog.value = true))
                                }, {
                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                            _createTextVNode(" Add User ", -1)
                                        ]))]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        (initialLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createVNode(_component_v_progress_circular, {
                                    indeterminate: "",
                                    color: "primary",
                                    size: "48"
                                })
                            ]))
                            : (error.value)
                                ? (_openBlock(), _createBlock(_component_v_alert, {
                                    key: 1,
                                    type: "error",
                                    variant: "tonal",
                                    class: "ma-4"
                                }, {
                                    append: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                            variant: "text",
                                            color: "error",
                                            onClick: loadData
                                        }, {
                                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                    _createTextVNode("Retry", -1)
                                                ]))]),
                                            _: 1
                                        })
                                    ]),
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(error.value) + " ", 1)
                                    ]),
                                    _: 1
                                }))
                                : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: searchQuery.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((searchQuery).value = $event)),
                                        "prepend-inner-icon": "mdi-magnify",
                                        label: "Search users...",
                                        variant: "outlined",
                                        density: "compact",
                                        "hide-details": "",
                                        clearable: "",
                                        class: "mb-4"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_v_data_table, {
                                        headers: headers,
                                        items: filteredUsers.value,
                                        loading: loading.value,
                                        expanded: expandedRows.value,
                                        "onUpdate:expanded": _cache[2] || (_cache[2] = ($event) => ((expandedRows).value = $event)),
                                        class: "elevation-0",
                                        "item-value": "username",
                                        "show-expand": ""
                                    }, {
                                        "item.username": _withCtx(({ item }) => [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createVNode(_component_v_avatar, {
                                                    size: "32",
                                                    color: "primary",
                                                    class: "mr-3"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("span", _hoisted_6, _toDisplayString(item.username.charAt(0).toUpperCase()), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createElementVNode("span", _hoisted_7, _toDisplayString(item.username), 1)
                                            ])
                                        ]),
                                        "item.display_name": _withCtx(({ item }) => [
                                            (item.display_name)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.display_name), 1))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_9, "Not set"))
                                        ]),
                                        "item.is_admin": _withCtx(({ item }) => [
                                            _createVNode(_component_v_chip, {
                                                color: item.is_admin ? 'primary' : 'grey',
                                                variant: "tonal",
                                                size: "small"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.is_admin ? "Admin" : "User"), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["color"])
                                        ]),
                                        "item.search_permissions_on_base_uris": _withCtx(({ item }) => [
                                            _createElementVNode("div", _hoisted_10, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item.search_permissions_on_base_uris || []).slice(0, 2), (uri) => {
                                                    return (_openBlock(), _createBlock(_component_v_chip, {
                                                        key: uri,
                                                        size: "x-small",
                                                        variant: "outlined",
                                                        color: "secondary"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(formatUri(uri)), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024));
                                                }), 128)),
                                                ((item.search_permissions_on_base_uris || []).length > 2)
                                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                                        key: 0,
                                                        size: "x-small",
                                                        variant: "text",
                                                        color: "grey"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(" +" + _toDisplayString(item.search_permissions_on_base_uris.length - 2) + " more ", 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024))
                                                    : _createCommentVNode("", true),
                                                ((item.search_permissions_on_base_uris || []).length === 0)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " None "))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]),
                                        "item.register_permissions_on_base_uris": _withCtx(({ item }) => [
                                            _createElementVNode("div", _hoisted_12, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item.register_permissions_on_base_uris || []).slice(0, 2), (uri) => {
                                                    return (_openBlock(), _createBlock(_component_v_chip, {
                                                        key: uri,
                                                        size: "x-small",
                                                        variant: "outlined",
                                                        color: "success"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(formatUri(uri)), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024));
                                                }), 128)),
                                                ((item.register_permissions_on_base_uris || []).length > 2)
                                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                                        key: 0,
                                                        size: "x-small",
                                                        variant: "text",
                                                        color: "grey"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(" +" + _toDisplayString(item.register_permissions_on_base_uris.length - 2) + " more ", 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024))
                                                    : _createCommentVNode("", true),
                                                ((item.register_permissions_on_base_uris || []).length === 0)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " None "))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]),
                                        "item.actions": _withCtx(({ item }) => [
                                            _createElementVNode("div", _hoisted_14, [
                                                _createVNode(_component_v_btn, {
                                                    icon: "mdi-delete",
                                                    size: "small",
                                                    variant: "text",
                                                    color: "error",
                                                    disabled: item.username === currentUsername.value,
                                                    onClick: ($event) => (openDeleteDialog(item))
                                                }, null, 8, ["disabled", "onClick"])
                                            ])
                                        ]),
                                        "expanded-row": _withCtx(({ columns, item }) => [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("td", {
                                                    colspan: columns.length,
                                                    class: "pa-4 bg-grey-lighten-4"
                                                }, [
                                                    _createElementVNode("div", _hoisted_16, [
                                                        _createElementVNode("div", _hoisted_17, [
                                                            _createVNode(_component_v_icon, {
                                                                size: "18",
                                                                class: "mr-2"
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                                        _createTextVNode("mdi-shield-key", -1)
                                                                    ]))]),
                                                                _: 1
                                                            }),
                                                            _createTextVNode(" Manage User: " + _toDisplayString(item.username), 1)
                                                        ]),
                                                        _createVNode(_component_v_card, {
                                                            variant: "outlined",
                                                            class: "pa-3 mb-3"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("div", _hoisted_18, [
                                                                    _createVNode(_component_v_icon, {
                                                                        size: "18",
                                                                        class: "mr-2",
                                                                        color: "primary"
                                                                    }, {
                                                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                                                _createTextVNode("mdi-badge-account", -1)
                                                                            ]))]),
                                                                        _: 1
                                                                    }),
                                                                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-body-2" }, "Display Name", -1))
                                                                ]),
                                                                _createElementVNode("div", _hoisted_19, [
                                                                    _createVNode(_component_v_text_field, {
                                                                        "model-value": pendingDisplayName[item.username] ??
                                                                            item.display_name ??
                                                                            '',
                                                                        label: "Display name (optional)",
                                                                        variant: "outlined",
                                                                        density: "compact",
                                                                        "hide-details": "",
                                                                        clearable: "",
                                                                        class: "flex-grow-1",
                                                                        "onUpdate:modelValue": (val) => (pendingDisplayName[item.username] = val || '')
                                                                    }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                                                    _createVNode(_component_v_btn, {
                                                                        icon: "mdi-check",
                                                                        size: "small",
                                                                        color: "primary",
                                                                        variant: "tonal",
                                                                        disabled: (pendingDisplayName[item.username] ??
                                                                            item.display_name ??
                                                                            '') === (item.display_name ?? ''),
                                                                        loading: savingDisplayName.value === item.username,
                                                                        onClick: ($event) => (saveDisplayName(item.username))
                                                                    }, null, 8, ["disabled", "loading", "onClick"])
                                                                ])
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_card, {
                                                            variant: "outlined",
                                                            class: "pa-3 mb-3"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("div", _hoisted_20, [
                                                                    _createElementVNode("div", _hoisted_21, [
                                                                        _createVNode(_component_v_icon, {
                                                                            size: "18",
                                                                            class: "mr-2",
                                                                            color: "primary"
                                                                        }, {
                                                                            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                                                    _createTextVNode("mdi-shield-account", -1)
                                                                                ]))]),
                                                                            _: 1
                                                                        }),
                                                                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-body-2" }, "Administrator Status", -1))
                                                                    ]),
                                                                    _createVNode(_component_v_switch, {
                                                                        "model-value": item.is_admin,
                                                                        color: "primary",
                                                                        density: "compact",
                                                                        "hide-details": "",
                                                                        disabled: item.username === currentUsername.value ||
                                                                            savingAdmin.value === item.username,
                                                                        loading: savingAdmin.value === item.username,
                                                                        "onUpdate:modelValue": (val) => val !== null &&
                                                                            toggleAdminStatus(item.username, val)
                                                                    }, null, 8, ["model-value", "disabled", "loading", "onUpdate:modelValue"])
                                                                ]),
                                                                (item.username === currentUsername.value)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, " You cannot change your own admin status "))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_row, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_col, {
                                                                    cols: "12",
                                                                    md: "6"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_v_card, {
                                                                            variant: "outlined",
                                                                            class: "pa-3"
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createElementVNode("div", _hoisted_23, [
                                                                                    _createVNode(_component_v_icon, {
                                                                                        size: "14",
                                                                                        class: "mr-1"
                                                                                    }, {
                                                                                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                                                                _createTextVNode("mdi-magnify", -1)
                                                                                            ]))]),
                                                                                        _: 1
                                                                                    }),
                                                                                    _cache[18] || (_cache[18] = _createTextVNode(" Search Permissions ", -1))
                                                                                ]),
                                                                                ((item.search_permissions_on_base_uris || [])
                                                                                    .length > 0)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                                                        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-caption mb-1" }, "Current:", -1)),
                                                                                        _createElementVNode("div", _hoisted_25, [
                                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.search_permissions_on_base_uris, (uri) => {
                                                                                                return (_openBlock(), _createBlock(_component_v_chip, {
                                                                                                    key: uri,
                                                                                                    size: "small",
                                                                                                    variant: "tonal",
                                                                                                    color: "secondary",
                                                                                                    closable: "",
                                                                                                    loading: savingPermission.value ===
                                                                                                        `search-revoke-${item.username}-${uri}`,
                                                                                                    "onClick:close": ($event) => (revokeSearchPermission(item.username, uri))
                                                                                                }, {
                                                                                                    default: _withCtx(() => [
                                                                                                        _createTextVNode(_toDisplayString(formatUri(uri)), 1)
                                                                                                    ]),
                                                                                                    _: 2
                                                                                                }, 1032, ["loading", "onClick:close"]));
                                                                                            }), 128))
                                                                                        ])
                                                                                    ]))
                                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_26, " No search permissions assigned ")),
                                                                                (getAvailableSearchUris(item).length > 0)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                                                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-caption mb-1" }, "Add permission:", -1)),
                                                                                        _createElementVNode("div", _hoisted_28, [
                                                                                            _createVNode(_component_v_select, {
                                                                                                modelValue: pendingSearchPermission[item.username],
                                                                                                "onUpdate:modelValue": ($event) => ((pendingSearchPermission[item.username]) = $event),
                                                                                                items: getAvailableSearchUris(item),
                                                                                                label: "Select base URI",
                                                                                                variant: "outlined",
                                                                                                density: "compact",
                                                                                                "hide-details": "",
                                                                                                class: "flex-grow-1"
                                                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]),
                                                                                            _createVNode(_component_v_btn, {
                                                                                                icon: "mdi-plus",
                                                                                                size: "small",
                                                                                                color: "secondary",
                                                                                                variant: "tonal",
                                                                                                disabled: !pendingSearchPermission[item.username],
                                                                                                loading: savingPermission.value ===
                                                                                                    `search-grant-${item.username}`,
                                                                                                onClick: ($event) => (grantSearchPermission(item.username))
                                                                                            }, null, 8, ["disabled", "loading", "onClick"])
                                                                                        ])
                                                                                    ]))
                                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_29, " All base URIs assigned "))
                                                                            ]),
                                                                            _: 2
                                                                        }, 1024)
                                                                    ]),
                                                                    _: 2
                                                                }, 1024),
                                                                _createVNode(_component_v_col, {
                                                                    cols: "12",
                                                                    md: "6"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_v_card, {
                                                                            variant: "outlined",
                                                                            class: "pa-3"
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createElementVNode("div", _hoisted_30, [
                                                                                    _createVNode(_component_v_icon, {
                                                                                        size: "14",
                                                                                        class: "mr-1"
                                                                                    }, {
                                                                                        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                                                                _createTextVNode("mdi-database-plus", -1)
                                                                                            ]))]),
                                                                                        _: 1
                                                                                    }),
                                                                                    _cache[22] || (_cache[22] = _createTextVNode(" Register Permissions ", -1))
                                                                                ]),
                                                                                ((item.register_permissions_on_base_uris || [])
                                                                                    .length > 0)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                                                                        _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-caption mb-1" }, "Current:", -1)),
                                                                                        _createElementVNode("div", _hoisted_32, [
                                                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.register_permissions_on_base_uris, (uri) => {
                                                                                                return (_openBlock(), _createBlock(_component_v_chip, {
                                                                                                    key: uri,
                                                                                                    size: "small",
                                                                                                    variant: "tonal",
                                                                                                    color: "success",
                                                                                                    closable: "",
                                                                                                    loading: savingPermission.value ===
                                                                                                        `register-revoke-${item.username}-${uri}`,
                                                                                                    "onClick:close": ($event) => (revokeRegisterPermission(item.username, uri))
                                                                                                }, {
                                                                                                    default: _withCtx(() => [
                                                                                                        _createTextVNode(_toDisplayString(formatUri(uri)), 1)
                                                                                                    ]),
                                                                                                    _: 2
                                                                                                }, 1032, ["loading", "onClick:close"]));
                                                                                            }), 128))
                                                                                        ])
                                                                                    ]))
                                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_33, " No register permissions assigned ")),
                                                                                (getAvailableRegisterUris(item).length > 0)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                                                        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-caption mb-1" }, "Add permission:", -1)),
                                                                                        _createElementVNode("div", _hoisted_35, [
                                                                                            _createVNode(_component_v_select, {
                                                                                                modelValue: pendingRegisterPermission[item.username],
                                                                                                "onUpdate:modelValue": ($event) => ((pendingRegisterPermission[item.username]) = $event),
                                                                                                items: getAvailableRegisterUris(item),
                                                                                                label: "Select base URI",
                                                                                                variant: "outlined",
                                                                                                density: "compact",
                                                                                                "hide-details": "",
                                                                                                class: "flex-grow-1"
                                                                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "items"]),
                                                                                            _createVNode(_component_v_btn, {
                                                                                                icon: "mdi-plus",
                                                                                                size: "small",
                                                                                                color: "success",
                                                                                                variant: "tonal",
                                                                                                disabled: !pendingRegisterPermission[item.username],
                                                                                                loading: savingPermission.value ===
                                                                                                    `register-grant-${item.username}`,
                                                                                                onClick: ($event) => (grantRegisterPermissionInline(item.username))
                                                                                            }, null, 8, ["disabled", "loading", "onClick"])
                                                                                        ])
                                                                                    ]))
                                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_36, " All base URIs assigned "))
                                                                            ]),
                                                                            _: 2
                                                                        }, 1024)
                                                                    ]),
                                                                    _: 2
                                                                }, 1024)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ])
                                                ], 8, _hoisted_15)
                                            ])
                                        ]),
                                        _: 1
                                    }, 8, ["items", "loading", "expanded"])
                                ]))
                    ]),
                    _: 1
                }),
                _createVNode(_component_v_dialog, {
                    modelValue: showAddUserDialog.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((showAddUserDialog).value = $event)),
                    "max-width": "500",
                    persistent: ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_card, { rounded: "lg" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "text-h6 pa-4 border-b" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                            size: "24",
                                            color: "primary",
                                            class: "mr-2"
                                        }, {
                                            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                                    _createTextVNode("mdi-account-plus", -1)
                                                ]))]),
                                            _: 1
                                        }),
                                        _cache[26] || (_cache[26] = _createTextVNode(" Add New User ", -1))
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_card_text, { class: "pa-4" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                            modelValue: newUser.username,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((newUser.username) = $event)),
                                            label: "Username",
                                            variant: "outlined",
                                            density: "compact",
                                            "error-messages": newUserErrors.username,
                                            class: "mb-4"
                                        }, null, 8, ["modelValue", "error-messages"]),
                                        _createVNode(_component_v_switch, {
                                            modelValue: newUser.is_admin,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((newUser.is_admin) = $event)),
                                            label: "Administrator",
                                            color: "primary",
                                            "hide-details": "",
                                            class: "mb-4"
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_card_actions, { class: "pa-4 pt-0" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                            variant: "text",
                                            onClick: closeAddUserDialog
                                        }, {
                                            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                                    _createTextVNode(" Cancel ", -1)
                                                ]))]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_btn, {
                                            color: "primary",
                                            variant: "tonal",
                                            loading: saving.value,
                                            onClick: createUser
                                        }, {
                                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                    _createTextVNode(" Add User ", -1)
                                                ]))]),
                                            _: 1
                                        }, 8, ["loading"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_dialog, {
                    modelValue: showDeleteDialog.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((showDeleteDialog).value = $event)),
                    "max-width": "400"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_card, { rounded: "lg" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "text-h6 pa-4 border-b" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                            size: "24",
                                            color: "error",
                                            class: "mr-2"
                                        }, {
                                            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                                    _createTextVNode("mdi-alert", -1)
                                                ]))]),
                                            _: 1
                                        }),
                                        _cache[30] || (_cache[30] = _createTextVNode(" Delete User ", -1))
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_card_text, { class: "pa-4" }, {
                                    default: _withCtx(() => [
                                        _cache[31] || (_cache[31] = _createTextVNode(" Are you sure you want to delete user ", -1)),
                                        _createElementVNode("strong", null, _toDisplayString(userToDelete.value?.username), 1),
                                        _cache[32] || (_cache[32] = _createTextVNode("? This action cannot be undone. ", -1))
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_card_actions, { class: "pa-4 pt-0" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                            variant: "text",
                                            onClick: _cache[6] || (_cache[6] = ($event) => (showDeleteDialog.value = false))
                                        }, {
                                            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                                    _createTextVNode(" Cancel ", -1)
                                                ]))]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_btn, {
                                            color: "error",
                                            variant: "tonal",
                                            loading: deleting.value,
                                            onClick: confirmDeleteUser
                                        }, {
                                            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                                    _createTextVNode(" Delete ", -1)
                                                ]))]),
                                            _: 1
                                        }, 8, ["loading"])
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
